/**
 * SlotChip — один чип сетки слотов (эталон slotChip js:334-344): тап по
 * времени — inline-правка (маска, Enter/Esc, deferred blur — не убивать клик
 * по соседней кнопке), ✕ — удалить, луна — ночной слот. Drag-состояние живёт
 * в SlotGridEditor и приходит обработчиками (long-press 350мс, js:346-356).
 */
import type { PointerEvent as ReactPointerEvent, RefObject } from "react";
import { CrossIco, MoonIco } from "./questIcons";
import css from "./quests.module.css";

export interface SlotChipProps {
  t: string;
  i: number;
  night: boolean;
  dragOn: boolean;
  editing: boolean;
  editVal: string;
  editBad: boolean;
  editInp: RefObject<HTMLInputElement | null>;
  onEditChange: (v: string) => void;
  onEditCommit: (i: number, ok: boolean) => void;
  onEditBlur: (i: number, t: string) => void;
  onEditStart: (i: number, t: string) => void;
  onDelete: (i: number) => void;
  onDown: (i: number, e: ReactPointerEvent<HTMLElement>) => void;
  onMove: (e: ReactPointerEvent<HTMLElement>) => void;
  onUp: (e: ReactPointerEvent<HTMLElement>) => void;
  onLeave: (e: ReactPointerEvent<HTMLElement>) => void;
}

export function SlotChip(p: SlotChipProps) {
  if (p.editing) {
    return (
      <span className={css.slot}>
        <input
          ref={p.editInp}
          className={`${css.sinp} ${p.editBad ? css.bad : ""}`}
          inputMode="numeric"
          value={p.editVal}
          onChange={(e) => p.onEditChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") p.onEditCommit(p.i, true);
            else if (e.key === "Escape") p.onEditCommit(p.i, false);
          }}
          onBlur={() => p.onEditBlur(p.i, p.t)}
        />
      </span>
    );
  }
  return (
    <span
      data-si={p.i}
      className={`${css.slot} ${p.dragOn ? css.drag : ""}`}
      onPointerDown={(e) => p.onDown(p.i, e)}
      onPointerMove={p.onMove}
      onPointerUp={p.onUp}
      onPointerCancel={p.onUp}
      onPointerLeave={p.onLeave}
      onContextMenu={(e) => e.preventDefault()}
    >
      <button type="button" className={`${css.st} ${css.num}`} onClick={() => p.onEditStart(p.i, p.t)}>
        {p.t}
      </button>
      {p.night ? <span className={css.moon}><MoonIco /></span> : null}
      {/* data-sx — маркер для drag-guard'а: эталон js:348 исключает ТОЛЬКО ✕ */}
      <button
        type="button"
        className={css.sx}
        data-sx=""
        onClick={(e) => { e.stopPropagation(); p.onDelete(p.i); }}
      >
        <CrossIco />
      </button>
    </span>
  );
}
